import * as Constantes from '../../shared/constants';

// Componentes
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { map, Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

//Modelos e Interfaces
import { IAlmacen } from 'src/app/interfaces/almacenes';
import { ICliente } from 'src/app/interfaces/cliente';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';
import { IPedido, IPedidoDetall } from 'src/app/interfaces/pedido';
import {
  MCampanyaPreparacionEstadosList,
  MPedidosEstadosList,
} from 'src/app/models/estadosList';

// Servicios
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { DatosAuxService } from 'src/app/services/datos/datosAux.service';
import { PedidosService } from 'src/app/services/datos/pedidos.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ModalPedidoCabeceraService } from '../../services/modal-pedido-cabecera.service';
import { RepartosService } from 'src/app/services/datos/repartos.service';
import { ModalFactSalidaService } from 'src/app/services/modal-fact-salida.service';
import { ModalAvisoPedidoService } from 'src/app/services/modal-pedido-aviso.service';
import { SidebarService } from 'src/app/services/sidebar.service';
import { ModalPedidoOrigenService } from 'src/app/services/modal-pedido-origen.service';

// Librerias y entornos
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import FuncLib from 'src/app/providers/funcionesLib';

@Component({
  selector: 'app-pedidos-lista',
  templateUrl: './pedidos-lista.component.html',
  styleUrls: ['./pedidos-lista.component.scss'],
})
export class PedidosListaComponent implements OnInit {

  // Importar la librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar las constantes en el template
  Constantes = Constantes;

  loading: boolean = false;
  public fotoDir: string = environment.fotoDir;

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  public lista: IPedido[] = []; // lista de pedidos

  almacenesList: IAlmacen[] = [];
  clientesList: ICliente[] = [];
  serviciosEnvioList: any[] = [];
  public estadosPreparacionList: any[] = MCampanyaPreparacionEstadosList;
  public pedidosEstadosList: any[] = MPedidosEstadosList;

  rows: any[] = [];
  temp: any[] = [];

  pedidoSelected: IPedido = {};
  pedidoDetall: IPedidoDetall = {};

  columns = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  paramId: number | string = 0;

  almSeleccionado: string = '';
  cliSeleccionado: string = '';
  cod_servicioSeleccionado: string = '';
  public estadoSelect: string = '0';

  // Cargar más
  public mostrarCargaMas: boolean = true; // si activamos un filtro, se desactiva el botón de cargar más
  concatData: boolean = false;
  recDesde: number = 0; // Desde dónde cargar
  recCuantos: number = parseInt(
    localStorage.getItem('recCuantosPedidos') || '300'
  ); // Cuantos cargar
  recTotal: number = 0; // Total de registros

  // Control de cuando se cierra el modal
  modalClosedSubscription: Subscription | undefined;

  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  @ViewChild(PedidosListaComponent) table: PedidosListaComponent | any;

  constructor(
    public pedidosSrv: PedidosService,
    public almacenesSrv: AlmacenesService,
    public clientesSrv: ClientesService,
    public userSrv: UsuarioService,
    private repartosSrv: RepartosService,
    public datosAuxSrv: DatosAuxService,
    private notificSrv: NotificacionesService,
    public modalPedidosCabeceraSrv: ModalPedidoCabeceraService,
    public modalFactSalidaSrv: ModalFactSalidaService,
    private activatedRoute: ActivatedRoute,
    public modalAvisoPedidoSrv: ModalAvisoPedidoService,
    public sidebarSrv: SidebarService,
    public modalPedidoOrigenSrv: ModalPedidoOrigenService,
  ) { }

  ngOnInit(): void {
    this.sidebarSrv.expandMenu('pedidos'); // Forzar el abrir menú de pedidos

    // Suscribirse a los parámetros de la url, si envían una id
    this.activatedRoute.params.subscribe(({ id }) => {
      this.paramId = id;
      this.getListaPedidos();
    });

    this.getAlmaceneLists();
    this.getClientesList();
    this.getListaServicios();

    this.getListaPedidos();
  }

  getListaPedidos() {
    const opciones: IListaOpciones = {};

    // Envían id por URL ó Envían pedido_cli a buscar por URL
    if (this.paramId) {
      const paramStr = String(this.paramId);
      if (paramStr.startsWith('P')) {
        opciones.pedido_cli = paramStr.substring(1); // filtrar por pedido_cli sin la 'P'
      } else {
        opciones.id = Number(this.paramId);
      }
    }

    opciones.id_cliente = parseInt(this.cliSeleccionado);
    opciones.estado = parseInt(this.estadoSelect) || 0;
    opciones.cod_servicio = this.cod_servicioSeleccionado;
    opciones.totalesPorEstado = '1';
    opciones.uicsDelPedido = '1';
    opciones.recDesde = this.recDesde;
    opciones.recCuantos = this.recCuantos;

    // Tomar los pedidos con acción pendiente
    if (this.paramId == 'A') {
      opciones.totalesPorEstado = '0';
      opciones.accionPendiente = '1';
    }

    this.loading = true;
    this.pedidosSrv.getLista(opciones).subscribe((resp) => {
      console.log('__getListaPedidos() opciones', opciones);
      console.log('__getListaPedidos() resp', resp);

      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }

      this.recTotal = parseInt(resp.totales.totalRegistros);

      if (this.concatData) {
        this.lista = this.lista.concat(resp.data);
      } else {
        this.lista = resp.data;
      }
      this.concatData = false;

      console.log('__getListaPedidos() recDesde: ', this.recDesde);
      console.log('__getListaPedidos() recTotal: ', this.recTotal);

      this.actualizarEstados(resp.totales.totalesPorEstado);

      this.rows = this.lista;
      this.temp = [...this.lista];

      //if (!this.pedidoSelected) this.pedidoSelected = this.lista[0];
      this.pedidoSelected = {};

      if (this.paramId == 'A') this.infoClickPedido(this.lista[0]);
      //  this.limpiaBusca();
    });
  }

  cargaMas() {
    this.concatData = true;
    this.recDesde += this.recCuantos;
    if (this.recDesde > this.recTotal) this.recDesde = this.recTotal;

    console.log('__cargaMas() recDesde: ', this.recDesde);
    console.log('__cargaMas() recCuantos: ', this.recCuantos);
    console.log('__cargaMas() recTotal: ', this.recTotal);

    this.getListaPedidos();
  }

  getAlmaceneLists() {
    this.almacenesSrv.getLista().subscribe((respuesta) => {
      this.almacenesList = respuesta.data;
    });
  }

  getClientesList() {
    this.clientesSrv.getLista().subscribe((resp) => {
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  getListaServicios() {
    this.datosAuxSrv.getListaServicios().subscribe((resp) => {
      console.log('__getListaServicios() resp', resp);

      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      this.serviciosEnvioList = resp.data;
    });
  }

  // Actualizar this.estados.cantidad con el número de registros
  public actualizarEstados(totalesPorEstado: any) {
    this.pedidosEstadosList.forEach((estado) => {
      estado.cantidad = 0;
      if (totalesPorEstado[estado.valor]) {
        estado.cantidad = totalesPorEstado[estado.valor];
      }
    });
  }

  // Estilo para la fila seleccionada
  getRowClass = (row: any) => {
    return {
      infoSelectRow: this.pedidoSelected && row.id === this.pedidoSelected.id,
    };
  };

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.lista;

    this.pedidoSelected = this.rows[0];

    console.log('__filtro() ', campo, val, this.rows.length, this.rows);
    if (val !== '') this.mostrarCargaMas = false;
    if (val == '') this.mostrarCargaMas = true;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  /// Búsqueda Global ///

  buscarTodo() {
    console.log('__buscarTodo() ', this.strBuscarTodo);
    this.mostrarCargaMas = this.strBuscarTodo === '';

    const txt = this.strBuscarTodo?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );
    this.textoDestacado = txt;
    this.rows = temp;
    this.table = this.lista;
    this.pedidoSelected = this.rows[0];
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscarTodo();
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  // busquedas parciales

  buscaEstado(evento: any) {
    const txt: string = evento.value;
    this.filtro(txt, 'estado');
  }

  buscaTipo(evento: any) {
    const txt: string = evento.value.toLowerCase();
    this.filtro(txt, 'tipoPedido');
  }

  // buscaServicio(evento: any) {
  //   const txt: string = evento.value;
  //   this.filtro(txt, 'cod_servicio');
  // }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  onAlmacenSelect(id: string) {
    this.almSeleccionado = id;
    this.getListaPedidos();
    this.pedidoDetall = {};
    this.strBuscarTodo = '';
  }

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.recDesde = 0;
    this.getListaPedidos();
    this.pedidoDetall = {};
    this.strBuscarTodo = '';
  }

  // onEstadoPedidoSelect(id: string) {
  //   this.estadoSelect = id;
  //   this.getListaPedidos();
  //   this.pedidoDetall = {};
  //   this.strBuscarTodo = '';
  // }

  onServicioSelect(cod_servicio: string) {
    this.cod_servicioSeleccionado = cod_servicio;
    this.getListaPedidos();
    this.pedidoDetall = {};
    this.strBuscarTodo = '';
  }

  estadoSelectChange(estadoSelect: string) {
    this.estadoSelect = estadoSelect;
    this.recDesde = 0;
    this.getListaPedidos();
    this.pedidoDetall = {};
    this.strBuscarTodo = '';
  }

  //  CRUD  //
  abrirModalFacturacion(pedido: IPedido, rowIndex: number) {
    this.modalFactSalidaSrv.pedido = pedido;
    this.pedidoDetall = pedido;
    this.modalFactSalidaSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalFactSalidaSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);
      this.actualizarLineaPedido(pedido, rowIndex);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }

  abrirModalCabeza(pedido: IPedido, rowIndex: number) {
    // this.infoClickPedido(pedido);
    // this.notificSrv.aviso('info', `editar pedido ${pedido.pedido_cli}`)
    this.modalPedidosCabeceraSrv.pedido = pedido;
    this.modalPedidosCabeceraSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalPedidosCabeceraSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);

      this.actualizarLineaPedido(pedido, rowIndex);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }

  crearComplementario(pedido: IPedido, rowIndex: number) {
    console.log('_crearComplementario con el pedido:', pedido, rowIndex);
    let texto = `¿Quieres crear un pedido complementario para el pedido <b>${pedido.pedido_cli}</b> con los artículos NO servidos?`;
    if (pedido.i_complemetarios) {
      texto = `<h1 class="text-danger">Atención</h1><br>El pedido <b>${pedido.pedido_cli}</b> ya tiene pedidos complementarios, asegurate de no duplicar pedidos`;
    }
    Swal.fire({
      title: '¿Crear complementario?',
      html: texto,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, crear',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.pedidosSrv.crearComplementario(pedido.id!).subscribe((resp: any) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', 'Pedido complementario creado');
          this.getListaPedidos();
        });
      }
    });
  }

  private actualizarLineaPedido(pedido: IPedido, rowIndex: number) {
    // Actualizar la fila del pedido modificado
    const opciones: IListaOpciones = { id: pedido.id };
    this.pedidosSrv.getLista(opciones).subscribe((resp: any) => {
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      pedido = resp.data[0];
      const newRows = [...this.rows];
      newRows[rowIndex] = { ...pedido };

      // Reasignamos para que ngx-datatable detecte cambios
      this.rows = newRows;
      console.log(
        '__se ha modificado this.rows[rowIndex] :',
        rowIndex,
        this.rows[rowIndex]
      );
    });
  }

  abrirModalAvisos(pedido: IPedido) {
    //  this.infoClickPedido(pedido);
    // this.notificSrv.aviso('info', `Notificaciones del pedido ${pedido.pedido_cli}`)
    this.modalAvisoPedidoSrv.pedido = pedido;
    this.modalAvisoPedidoSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalAvisoPedidoSrv.modalClosed.subscribe(() => {
      console.log('El modalAvisoPedido ha sido cerrado!');
      sub.unsubscribe();
    });
  }


  // MODAL PEDIDO ORIGEN
  abrirModalOrigenPedido(pedido: IPedido, rowIndex: number) {

    console.log('_abrirModalOrigenPedido con el pedido:', pedido, rowIndex);

    this.modalPedidoOrigenSrv.pedido = pedido;
    this.modalPedidoOrigenSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalPedidoOrigenSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }



  pdfEtiquetaPedido(row: IPedido) {
    // Imprimir una etiqueta del pedido

    this.infoClickPedido(row);
    console.log('__imprimeEtiqueta() ', row);

    const data = {
      id_pedido: row.id,
      id_usuario: this.userSrv.userdata.id,
    };

    Swal.fire({
      title: 'Imprimir etiqueta',
      text: `¿Imprimir la etiqueta del pedido ${row.pedido_cli}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, imprimir',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.pedidosSrv.pedidoLabel(data).subscribe((resp) => {
          this.loading = false;
          console.log('__pedidoLabel', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          }
        });
      }
    });
  }

  infoClickPedido(row: any) {
    // Info sobre un pedido

    this.pedidoSelected = row;
    console.log(
      '__infoClickPedido click  this.pedidoSelected',
      this.pedidoSelected
    );

    // Destacar línea seleccionada en negrita
    this.rows.forEach((r: any) => {
      r.destacarLinea = false;
    });
    row.destacarLinea = true;

    // Scroll hacia el elemento detallesPedido
    setTimeout(() => {
      const element = document.getElementById('detallesPedido');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100); // Un pequeño retraso para asegurar que la UI se ha actualizado
  }

  //  AUX //

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `Pedidos-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  public sumaCeldas(cells: any[]): number {
    const filteredCells = cells.filter((cell) => !!cell);
    const sum = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    return sum.toLocaleString('de-DE');
  }

  public nada(cells: any[]): string {
    return '';
  }

  descargaAlbaranClick(id_pedido: number) {
    console.log('__descargaAlbaranClick() id_pedido=', id_pedido);
    this.loading = true;
    this.pedidosSrv.downloadAlbaran(id_pedido).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
        return;
      }
      const urlPdf: string = environment.pdfDir + '/' + resp.data;
      window.open(urlPdf, '_blank');
    });
  }


  // Descargar albarán en XLS
  descargaAlbaranXls(id_pedido: number) {
    const url = environment.xlsDir + '/albaranes' + `/albaran_${id_pedido}.xlsx`;
    console.log('__descargaAlbaranXls() url:', url);

    this.loading = true;

    // Verificar si el archivo existe comprobando el Content-Type
    fetch(url, { method: 'HEAD' })
      .then(response => {
        this.loading = false;
        const contentType = response.headers.get('Content-Type');

        // Verificar si es un archivo Excel (no JSON de error)
        const isExcelFile = contentType && (
          contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          contentType.includes('application/vnd.ms-excel') ||
          contentType.includes('application/octet-stream')
        );

        if (response.ok && isExcelFile) {
          // El archivo Excel existe, abrirlo
          window.open(url, '_blank');
        } else {
          // El archivo no existe o es un JSON de error
          console.error('Archivo no encontrado. Status:', response.status, 'Content-Type:', contentType);
          this.notificSrv.aviso('error', 'El archivo Excel no está disponible');
        }
      })
      .catch(error => {
        this.loading = false;
        console.error('Error verificando archivo:', error);
        window.open(url, '_blank');
      });
  }





  generaXlsEnvio(pedido: IPedido) {
    // Genera el archivo XLS de envío de un pedido

    const data = {
      id_pedido: pedido.id,
      id_usuario: this.userSrv.userdata.id,
    };

    Swal.fire({
      title: 'Generar Etiqueta de envío',
      text: `¿Generar XLS para exportar el pedido a DTX?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar etiqueta',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.repartosSrv.endpointGeneraXlsEnvio(data).subscribe((resp) => {
          this.loading = false;
          console.log('__generaXlsEnvio()', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          }
        });
      }
    });
  }

  generaPdfEnvio(pedido: IPedido) {
    // Genera el archivo PDF de envío de un pedido

    console.log('__generaPdfEnvio() ', pedido);

    const data = {
      id_pedido: pedido.id,
      id_usuario: this.userSrv.userdata.id,
    };

    Swal.fire({
      title: 'Generar Packing List de envío',
      text: `¿Generar el albarán Packing List del pedido ${pedido.pedido_cli}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar documento',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.repartosSrv.pdfAlbaran(data).subscribe((resp) => {
          this.loading = false;
          console.log('__generaPdfEnvio()', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          this.descargaAlbaranClick(pedido.id!);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          }
        });
      }
    });
  }



  labelCajas(pedido: IPedido) {
    // Imprime el contenido de las cajas de un pedido
    console.log('__labelCajas() ', pedido);

    this.getInfoCajas(pedido.id!).subscribe(infoCajas => {
      if (!infoCajas || !infoCajas.length) {
        this.notificSrv.aviso('info', 'No hay información de cajas para este pedido.');
        return;
      }

      // Filtrar cajas con número 0
      infoCajas = infoCajas.filter((item: any) => Number(item.caja_num) !== 0);

      if (!infoCajas.length) {
        this.notificSrv.aviso('info', 'No hay información de cajas para este pedido.');
        return;
      }

      // Obtener cajas únicas
      const cajasUnicas = [...new Map(
        infoCajas.map((item: any) => [item.caja_num, item])
      ).values()].sort((a: any, b: any) => Number(a.caja_num) - Number(b.caja_num));

      // Crear opciones para el select
      const selectOptions: Record<string, string> = cajasUnicas.reduce((options: Record<string, string>, caja: any) => {
        if (caja.caja_uic) {
          options[caja.caja_num] = `Caja ${caja.caja_num} - ${caja.caja_uic}`;
        } else {
          options[caja.caja_num] = `Caja ${caja.caja_num}`;
        }
        return options;
      }, { 'todas': 'Imprimir todas las cajas' });

      Swal.fire({
        title: 'Imprimir contenido de cajas',
        text: `Selecciona qué caja imprimir del pedido ${pedido.pedido_cli}`,
        icon: 'question',
        input: 'select',
        inputOptions: selectOptions,
        inputPlaceholder: 'Selecciona una caja',
        showCancelButton: true,
        confirmButtonText: 'Imprimir',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value) {
            return 'Debes seleccionar alguna caja';
          }
          return null;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const cajaSeleccionada = result.value;

          const data = {
            id_pedido: pedido.id,
            id_usuario: this.userSrv.userdata.id,
            caja_num: cajaSeleccionada === 'todas' ? null : cajaSeleccionada
          };

          this.loading = true;
          this.pedidosSrv.labelCajas(data).subscribe((resp) => {
            this.loading = false;
            console.log('__labelCajas()', resp);
            this.notificSrv.aviso('info', resp.mensaje);
            if (resp.error) {
              this.notificSrv.aviso('error', resp.mensaje);
            }
          });
        }
      });
    });
  }


  getInfoCajas(id_pedido: number): Observable<any> {
    this.loading = true;
    return this.repartosSrv.getRepartoCajas(id_pedido).pipe(
      map(resp => {
        this.loading = false;
        console.log('__getRepartoCajas()', resp);
        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return null;
        }
        return resp.data;
      })
    );
  }





  openTracking(id_pedido: number) {
    this.loading = true;

    console.log('__openTracking() id_pedido', id_pedido);

    this.pedidosSrv.getPedido(id_pedido).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
        return;
      }
      if (resp.data.ref_envio == null) {
        this.notificSrv.aviso(
          'warning',
          'No se ha encontrado referencia de envío para este pedido'
        );
        return;
      }
      console.log('__openTracking() resp.data', resp.data);
      const urlTracking = `${environment.url_cliente}/seg/${resp.data.cliNombreCorto}/?ref=${resp.data.ref_envio}`;
      window.open(urlTracking, '_blank');
    });
  }
}
